import { tv } from "tailwind-variants";

export const button = tv({
    base: [
        "tw:text-base tw:inline-block tw:text-center tw:select-none",
        "tw:not-disabled:cursor-pointer",
        "tw:relative",
        "tw:transition-[background-color,color,box-shadow]",
        "tw:disabled:opacity-65",
        "tw:focus-visible:outline-none!",
        "tw:rounded-sm!",

        "tw:group-[*]/inputgroup:not-first:rounded-l-none!",
        "tw:group-[*]/inputgroup:not-last:rounded-r-none!",
        "tw:group-[*]/inputgroup:not-last:-mr-px!"
    ],

    variants: {
        color: {
            "primary": "",
            "success": "",
            "danger": "",
            "dark": "",
            "warning": "",
            "transparent": "",
            "gray": "",
            "light-gray": "",
            "link": ""
        },

        outline: {
            false: "",
            true: ""
        },

        size: {
            sm: "tw:px-2 tw:py-1 tw:text-sm!",
            md: "tw:px-3 tw:py-1.5 tw:text-base!",
            lg: "tw:px-4 tw:py-2 tw:text-xl!"
        },

        fullWidth: {
            true: "tw:w-full"
        },

        loading: {
            true: [
                "tw:before:content-['']",
                "tw:before:animate-loading-bar",
                "tw:before:block tw:before:h-full tw:before:w-10",
                "tw:before:absolute tw:before:top-0 tw:before:left-0",
                "tw:before:p-0 tw:before:opacity-30"
            ]
        }
    },

    compoundVariants: [
        // OUTLINE + COLOR
        {
            outline: false,
            color: "primary",
            class: "tw:text-white tw:bg-primary tw:hover:bg-primary-focus tw:focus:bg-primary-focus tw:focus:ring-3 tw:ring-primary/40"
        },
        {
            outline: false,
            color: "success",
            class: "tw:text-white tw:bg-success tw:hover:bg-success-focus tw:focus:bg-success-focus tw:focus:ring-3 tw:ring-success/40"
        },
        {
            outline: false,
            color: "danger",
            class: "tw:text-white tw:bg-danger tw:hover:bg-danger-focus tw:focus:bg-danger-focus tw:focus:ring-3 tw:ring-danger/40"
        },
        {
            outline: false,
            color: "dark",
            class: "tw:text-white tw:bg-dark tw:hover:bg-dark-focus tw:focus:bg-dark-focus tw:focus:ring-3 tw:ring-dark-focus/50"
        },
        {
            outline: false,
            color: "warning",
            class: "tw:text-white tw:bg-warning tw:hover:bg-warning-focus tw:focus:bg-warning-focus tw:focus:ring-3 tw:ring-warning-focus/50"
        },
        {
            outline: false,
            color: "transparent",
            class: "tw:bg-transparent tw:hover:bg-grey-input tw:focus:bg-grey-input tw:focus:ring-3 tw:ring-grey-input/50"
        },
        {
            outline: false,
            color: "gray",
            class: "tw:bg-grey-light tw:hover:bg-grey-input tw:focus:bg-grey-input tw:focus:ring-3 tw:ring-grey-input/50 tw:text-black"
        },
        {
            outline: false,
            color: "light-gray",
            class: "tw:bg-grey tw:hover:bg-grey-light tw:focus:bg-grey-light tw:focus:ring-3 tw:ring-grey-light/50 tw:text-black"
        },
        {
            outline: false,
            color: "link",
            class: "tw:text-information tw:hover:text-information-focus tw:hover:underline tw:focus:text-information-focus tw:focus:underline"
        },
        {
            outline: true,
            color: "primary",
            class: "tw:text-primary tw:border tw:border-primary tw:bg-transparent tw:hover:bg-primary tw:hover:text-white tw:focus:ring-3 tw:ring-primary/40"
        },
        {
            outline: true,
            color: "success",
            class: "tw:text-success tw:border tw:border-success tw:bg-transparent tw:hover:bg-success tw:hover:text-white tw:focus:ring-3 tw:ring-success/40"
        },
        {
            outline: true,
            color: "danger",
            class: "tw:text-danger tw:border tw:border-danger tw:bg-transparent tw:hover:bg-danger tw:hover:text-white tw:focus:ring-3 tw:ring-danger/40"
        },
        {
            outline: true,
            color: "dark",
            class: "tw:text-dark tw:border tw:border-dark tw:bg-transparent tw:hover:bg-dark tw:hover:text-white tw:focus:ring-3 tw:ring-dark/40"
        },
        {
            outline: true,
            color: "warning",
            class: "tw:text-warning tw:border tw:border-warning tw:bg-transparent tw:hover:bg-warning tw:hover:text-white tw:focus:ring-3 tw:ring-warning/40"
        },
        {
            outline: true,
            color: "transparent",
            class: "tw:bg-transparent tw:hover:bg-grey-input tw:focus:bg-grey-input tw:focus:ring-3 tw:ring-grey-input/50"
        },
        {
            outline: true,
            color: "gray",
            class: "tw:text-grey-light tw:border tw:border-grey-light tw:bg-transparent tw:hover:bg-grey-light tw:hover:text-black tw:focus:ring-3 tw:ring-grey-light/40"
        },
        {
            outline: true,
            color: "light-gray",
            class: "tw:text-grey tw:border tw:border-grey tw:bg-transparent tw:hover:bg-grey tw:hover:text-black tw:focus:ring-3 tw:ring-grey/40"
        },
        {
            outline: true,
            color: "link",
            class: "tw:text-information tw:hover:text-information-focus tw:hover:underline tw:focus:text-information-focus tw:focus:underline"
        },

        // LOADING + COLOR
        {
            loading: true,
            color: "primary",
            class: "tw:before:bg-primary"
        },
        {
            loading: true,
            color: "success",
            class: "tw:before:bg-success"
        },
        {
            loading: true,
            color: "danger",
            class: "tw:before:bg-danger"
        },
        {
            loading: true,
            color: "dark",
            class: "tw:before:bg-dark"
        },
        {
            loading: true,
            color: "warning",
            class: "tw:before:bg-warning"
        },
        {
            loading: true,
            color: "transparent",
            class: "tw:before:bg-transparent"
        },
        {
            loading: true,
            color: "gray",
            class: "tw:before:bg-grey-light"
        },
        {
            loading: true,
            color: "light-gray",
            class: "tw:before:bg-grey"
        },
        {
            loading: true,
            color: "link",
            class: "tw:before:bg-information"
        }
    ],

    defaultVariants: {
        size: "md",
        outline: false,
        color: "primary",
        fullWidth: false,
        loading: false
    }
});
